module.exports = __webpack_public_path__ + "static/media/logo-gets.1c85ede1.svg";